export default __webpack_public_path__ + "static/jakob-e13a67aabc54067a218b8bdd81699bc7.png";